module.exports = __webpack_public_path__ + "img/receive.b9b76440.svg";